import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcNotes = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g stroke="currentColor" strokeWidth={2} fill="none" fillRule="evenodd">
      <path d="M25 7v15.605L19.565 28H7V7h18Z" />
      <path d="M25.025 22.023H18.96v5.99M20.036 10.51c1.105 0 2-1.567 2-3.5s-.895-3.5-2-3.5c-1.104 0-2 1.567-2 3.5M12.036 10.51c1.105 0 2-1.567 2-3.5s-.895-3.5-2-3.5c-1.104 0-2 1.567-2 3.5" />
    </g>
  </svg>
);
export default SvgIcNotes;
